import React from 'react';
import { BaseResponsiveSearchCard } from '../Base/Responsive';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  DisclaimerContentText,
} from '../Base/styles';
import { BoxConditionIcon, TruckIcon, MapMarkerIcon } from '../../../../assets';

const StyledContentText = styled(DisclaimerContentText)`
  white-space: normal;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[3].rem} ${theme.spacings[2].rem};
`;

const PriceCondition = styled.span`
  ${theme.typography.headings[5]['sm-lg']};
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

export const AutoBuyNowResponsiveSearchCard: React.FC<
  SearchCard<'AutoBuyNow'>
> = ({
  title,
  price,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseResponsiveSearchCard {...props}>
      <Content>
        <Title>{title}</Title>

        <Price>
          {price}
          <PriceCondition>*</PriceCondition>
        </Price>

        <StyledContentText>{data?.disclaimerText}</StyledContentText>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              (condition as string).length < 15 && (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              )
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseResponsiveSearchCard>
  );
};
